import { CodeInput, DiscountInput, ActiveInput } from "./PromoInputs";
import { PromoShowsInput } from "./PromoShowsInput";
import type { PromoShowOption } from "@/app/_services/PromoService";

export const PromoForm = ({
  control,
  errors,
  showOptions,
}: {
  control: any;
  errors: any;
  showOptions: PromoShowOption[];
}) => {
  return (
    <form id="promo-form" onSubmit={(e) => e.preventDefault()}>
      <div className="grid gap-4">
        <CodeInput control={control} errors={errors} />
        <DiscountInput control={control} errors={errors} />
        <PromoShowsInput control={control} errors={errors} showOptions={showOptions} />
        <ActiveInput control={control} errors={errors} />
      </div>
    </form>
  );
};
